import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { SectionLayoutType } from '../../../../../../../models/enum/dto/section-layout-type.enum';
import { map } from 'rxjs/operators';
import { PrintCardColumnViewModel } from '../../../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/print-card-column-view-model';
import { GlassHouseBrandGroupCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';
import type { Observable } from 'rxjs';

@Injectable()
export class GlassHouseBrandGroupIndexCardStackContentViewModel extends PrintCardContentViewModel {
  protected N_ITEMS_ON_CARD = 5;

  override cardData$: Observable<GlassHouseBrandGroupCardData>;

  public readonly cappedSpoofedGridColViewModels$ = this.spoofedGridColViewModels$.pipe(
    map(cols => cols?.take(this.N_ITEMS_ON_CARD))
  );

  public readonly plusNMoreCols$ = this.spoofedGridColViewModels$.pipe(
    map(cols => {
      const count = (cols?.length ?? 0) - this.N_ITEMS_ON_CARD;
      return count > 0 ? count : 0;
    })
  );

  public readonly priceStreamOverride$ = this.cardData$.pipe(
    map(cardData => cardData?.getOverridePriceStreamForLabelComponent())
  );

  /**
   * This is a round about way to get the data in the correct shape that I need.
   */
  protected override getSpoofedGridColumnVMs(cardData: GlassHouseBrandGroupCardData): PrintCardColumnViewModel[] {
    return cardData?.lineItems?.map(cardDataInception => {
      const variant = cardDataInception?.rowVariants?.firstOrNull();
      const spoofed = this.getSpoofedColumnVM(cardData, variant, SectionLayoutType.Grid);
      const layoutType = SectionLayoutType.Grid;
      const locationId = cardData?.locationConfig?.locationId;
      spoofed.columnTitle = variant?.getGridNames(layoutType, locationId)?.firstOrNull();
      return spoofed;
    });
  }
}
